<!-- Modal backdrop -->
<div
  class="fixed inset-0 z-[60] bg-black bg-opacity-30"
  (click)="onCancel()"
></div>

<!-- Modal container -->
<div class="fixed inset-0 top-[4.5rem] z-[65] flex items-start justify-center py-8 px-4 pointer-events-none">
  <div
    class="max-w-5xl w-full h-full pointer-events-auto"
    (click)="$event.stopPropagation()"
  >
      <!-- Main Content Area -->
      <div 
        class="flex flex-col bg-white dark:bg-gray-800 rounded-lg shadow-md h-full min-h-0 relative"
        role="dialog"
        aria-modal="true"
        aria-labelledby="configuration-title"
        (click)="$event.stopPropagation()"
      >
        <!-- Header with title and close button -->
        <div class="p-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 rounded-t-lg flex items-center gap-4 relative">
          <!-- Left: Title -->
          <div class="flex items-center">
            <span id="configuration-title" class="text-gray-700 dark:text-gray-300 text-xl md:text-3xl font-semibold whitespace-nowrap">
              {{ (isEditMode ? 'Edit Configuration' : 'Add Configuration') | transloco }}
            </span>
          </div>

          <!-- Tab info - pushed right -->
          <div
            class="flex flex-col items-end ml-auto"
            (click)="dropdownOpen = !dropdownOpen"
          >
            <span class="text-blue-800 text-xl font-semibold text-nowrap">
              {{ tabs[activeTab].name | transloco }}
            </span>
            <span class="text-center text-sm text-blue-800 font-medium">{{ activeTab + 1 }} of {{ tabs.length }}</span>
          </div>

          <!-- Mobile dropdown for tabs -->
          <div *ngIf="tabs.length > 1" class="flex md:hidden relative">
            <button
              type="button"
              class="inline-flex items-center px-3 py-2 rounded-md shadow-sm text-sm font-medium text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-400"
              (click)="dropdownOpen = !dropdownOpen"
              [attr.aria-label]="'Switch section' | transloco"
            >
              <svg class="ml-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" class="text-white" />
              </svg>
            </button>
            <div
              *ngIf="dropdownOpen"
              class="origin-top-right absolute right-0 mt-10 w-56 rounded-md shadow-lg bg-white dark:bg-gray-700 ring-1 ring-black ring-opacity-5 z-50"
            >
              <div class="py-1" role="menu">
                <button
                  *ngFor="let tab of tabs; let i = index"
                  (click)="selectTab(i); dropdownOpen = false"
                  class="block px-4 py-2 text-sm w-full text-left"
                  [ngClass]="{
                    'bg-blue-800 text-white shadow': activeTab === i,
                    'text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-600': activeTab !== i
                  }"
                  role="menuitem"
                >
                  {{ tab.name | transloco }}
                </button>
              </div>
            </div>
          </div>

          <!-- Vertical bar separator -->
          <div class="hidden md:flex w-0.5 bg-slate-300 dark:bg-slate-500 self-stretch"></div>

          <!-- Close button -->
          <div class="hidden md:flex">
            <button
              type="button"
              (click)="onCancel()"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
              [attr.aria-label]="'Close' | transloco"
            >
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Top shadow -->
        <div class="pointer-events-none w-full h-2 z-20 -mb-2"
             style="background: linear-gradient(to bottom, rgba(0,0,0,0.18), transparent);"></div>

        <!-- Middle section with nav and content -->
        <div class="flex-1 flex flex-row min-h-0">
          <!-- Tab side nav -->
          <nav
            *ngIf="tabs.length > 1"
            class="hidden md:flex flex-shrink-0 flex-col gap-2 w-52 px-3 py-2 pt-6 border-r border-gray-200 dark:border-gray-700"
            (click)="$event.stopPropagation()"
          >
            <button
              *ngFor="let tab of tabs; let i = index"
              type="button"
              class="px-2 py-1 rounded font-semibold transition-colors text-left"
              [ngClass]="{
                'bg-blue-800 text-white shadow': activeTab === i,
                'text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-200 dark:hover:bg-gray-700': activeTab !== i
              }"
              (click)="selectTab(i); $event.stopPropagation()"
            >
              {{ tab.name | transloco }}
            </button>
          </nav>

          <!-- Content area -->
          <div class="flex-1 flex flex-col min-h-0">
            <!-- Scrollable content area -->
            <div class="flex-1 overflow-y-auto px-6 pb-6 pt-4">
          <!-- Loading State -->
          <div *ngIf="isLoading" class="flex items-center justify-center py-12">
            <div class="text-center">
              <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
              <p class="mt-4 text-gray-600 dark:text-gray-400">{{ (isSaving ? 'Saving configuration' : 'Loading configuration') | transloco }}...</p>
            </div>
          </div>

          <!-- Form Content -->
          <form *ngIf="!isLoading" (ngSubmit)="onSave()">
            
            <!-- TAB 1: General -->
            <div *ngIf="activeTab === 0" class="space-y-6">
        
        <!-- Basic Information Section -->
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matSettingsOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'General Settings' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>
          
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Unit -->
            <div>
              <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                <label for="unitId" class="flex flex-row items-center">
                  <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Unit' | transloco }}
                </label>
              </div>
              <select
                id="unitId"
                [(ngModel)]="configuration.unitId"
                name="unitId"
                required
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              >
                <option [ngValue]="null" disabled>{{ 'Select Unit' | transloco }}</option>
                <option *ngFor="let unit of units" [ngValue]="unit.id">
                  {{ unit.name }}{{ unit.description ? ' - ' + unit.description : '' }}
                </option>
              </select>
            </div>

            <!-- Billing Factor -->
            <div>
              <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                <label for="billingFactor" class="flex flex-row items-center">
                  <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Billing Factor' | transloco }}
                </label>
              </div>
              <input
                id="billingFactor"
                [(ngModel)]="configuration.billingFactor"
                name="billingFactor"
                type="number"
                required
                min="1"
                autocomplete="off"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                {{ 'Number of units billed per unit (1, 10, 100, 1000, etc.)' | transloco }}
              </p>
            </div>

            <!-- Timezone -->
            <div>
              <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                <label for="timeZoneSelect">{{ 'Timezone' | transloco }}</label>
              </div>
              <app-searchable-select [field]="timezoneSelectField"></app-searchable-select>
              <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
                {{ 'Sets the timezone used for date/time display throughout the app.' | transloco }}
              </p>
            </div>

            <!-- Owner ID -->
            <div>
              <label for="ownerId" class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'Owner ID' | transloco }} <span class="text-gray-500 text-xs">({{ 'RFID Configuration' | transloco }})</span>
              </label>
              <input
                id="ownerId"
                [(ngModel)]="configuration.ownerId"
                name="ownerId"
                type="number"
                autocomplete="off"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
        </div>

        <!-- Logo Section -->
        <div *ngIf="isSuperUser">
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matSettingsOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Operator Logo' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>

          <div class="flex flex-col sm:flex-row items-start gap-6">
            <!-- Preview -->
            <div class="flex-shrink-0">
              <div
                class="w-32 h-32 rounded-lg border-2 border-dashed border-gray-300 dark:border-gray-600 flex items-center justify-center overflow-hidden bg-gray-50 dark:bg-gray-700"
              >
                <img
                  *ngIf="logoPreviewUrl"
                  [src]="logoPreviewUrl"
                  [attr.alt]="'Logo preview' | transloco"
                  class="w-full h-full object-contain"
                />
                <span *ngIf="!logoPreviewUrl" class="text-xs text-gray-400 dark:text-gray-500 text-center px-2">
                  {{ 'No logo selected' | transloco }}
                </span>
              </div>
            </div>

            <!-- Actions -->
            <div class="flex flex-col gap-3 justify-center">
              <label
                class="cursor-pointer inline-flex items-center gap-2 px-4 py-2 bg-blue-800 hover:bg-blue-900 text-white text-sm font-medium rounded-lg transition-colors duration-200"
              >
                <ng-icon name="matAddOutline" size="16"></ng-icon>
                {{ 'Upload Logo' | transloco }}
                <input
                  type="file"
                  accept="image/jpeg,image/png"
                  class="hidden"
                  (change)="onLogoFileSelected($event)"
                />
              </label>
              <button
                *ngIf="logoPreviewUrl"
                type="button"
                (click)="removeLogo()"
                class="inline-flex items-center gap-2 px-4 py-2 border border-red-300 dark:border-red-600 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 text-sm font-medium rounded-lg transition-colors duration-200"
              >
                <ng-icon name="matDeleteOutline" size="16"></ng-icon>
                {{ 'Remove Logo' | transloco }}
              </button>
              <p class="text-xs text-gray-500 dark:text-gray-400">
                {{ 'Supported formats: PNG, JPG, GIF, SVG. Max size: 2 MB.' | transloco }}
              </p>
            </div>
          </div>
        </div>

        <!-- Contact Information Section -->
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matPhone" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Operator and Contact Info' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Name -->
            <div class="md:col-span-2">
              <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                <label for="name" class="flex flex-row items-center">
                  <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Operator Name' | transloco }}
                </label>
              </div>
              <input
                id="name"
                [(ngModel)]="configuration.name"
                name="name"
                type="text"
                required
                maxlength="128"
                autocomplete="off"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>

            <!-- Phone -->
            <div>
              <label for="phone" class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'Phone' | transloco }}
              </label>
              <input
                id="phone"
                [(ngModel)]="configuration.phone"
                name="phone"
                type="tel"
                maxlength="50"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>

            <!-- Email -->
            <div>
              <label for="email" class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'Email' | transloco }}
              </label>
              <input
                id="email"
                [(ngModel)]="configuration.email"
                name="email"
                type="email"
                maxlength="128"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
        </div>

        <!-- Address Section -->
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matLocationOn" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Address' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>
          
          <div class="space-y-3">
            <!-- Street 1 - Full Width -->
            <div>
              <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                <label for="street1" class="flex flex-row items-center">
                  <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Street Address Line 1' | transloco }}
                </label>
              </div>
              <input
                id="street1"
                [(ngModel)]="configuration.address.street1"
                name="street1"
                type="text"
                required
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>
            
            <!-- Street 2 - Full Width -->
            <div>
              <label for="street2" class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'Street Address Line 2' | transloco }} ({{ 'optional' | transloco }})
              </label>
              <input
                id="street2"
                [(ngModel)]="configuration.address.street2"
                name="street2"
                type="text"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>
            
            <!-- Row 1: City and Postal Code -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                  <label for="city" class="flex flex-row items-center">
                    <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'City' | transloco }}
                  </label>
                </div>
                <input
                  id="city"
                  [(ngModel)]="configuration.address.city"
                  name="city"
                  type="text"
                  required
                  (ngModelChange)="checkForChanges()"
                  class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                />
              </div>
              
              <div>
                <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                  <label for="postalCode" class="flex flex-row items-center">
                    <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ postalCodeLabel | transloco }}
                  </label>
                </div>
                <input
                  id="postalCode"
                  [(ngModel)]="configuration.address.postalCode"
                  name="postalCode"
                  type="text"
                  required
                  (ngModelChange)="checkForChanges()"
                  class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                />
              </div>
            </div>
            
            <!-- Row 2: Country and District -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                  <label for="countryId" class="flex flex-row items-center">
                    <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ 'Country' | transloco }}
                  </label>
                </div>
                <select
                  id="countryId"
                  [(ngModel)]="configuration.address.countryId"
                  name="countryId"
                  required
                  (ngModelChange)="onCountryChange($event)"
                  class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                >
                  <option [ngValue]="null" disabled selected>{{ 'Select Country' | transloco }}</option>
                  <option *ngFor="let country of countries" [ngValue]="country.id">
                    {{ country.name }}
                  </option>
                </select>
              </div>

              <div>
                <div class="mb-1 text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 flex flex-row items-center justify-between">
                  <label for="districtId" class="flex flex-row items-center">
                    <span class="text-red-600 dark:text-red-500 mr-1">*</span>{{ districtLabel | transloco }}
                  </label>
                </div>
                <select
                  id="districtId"
                  [(ngModel)]="configuration.address.districtId"
                  name="districtId"
                  required
                  [disabled]="!selectedCountryId || districts.length === 0"
                  (ngModelChange)="checkForChanges()"
                  class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white disabled:bg-gray-100 disabled:cursor-not-allowed dark:disabled:bg-gray-600"
                >
                  <option [ngValue]="null" disabled selected>{{ 'Select District' | transloco }}</option>
                  <option *ngFor="let district of districts" [ngValue]="district.id">
                    {{ district.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

      </div>  <!-- End General Tab -->
      
            <!-- TAB 2: SMS Settings -->
            <div *ngIf="activeTab === 1" class="space-y-6">
        <!-- SMS Settings Section -->
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matMessageOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'SMS Settings' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>

          <!-- SMS Enable Toggle -->
          <div class="flex items-center mb-4">
            <input
              id="smsEnable"
              [(ngModel)]="configuration.smsEnable"
              name="smsEnable"
              type="checkbox"
              (ngModelChange)="checkForChanges()"
              class="w-4 h-4 flex-shrink-0 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
            <label for="smsEnable" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              {{ 'Enable SMS Notifications' | transloco }}
            </label>
          </div>

          <!-- SMS Numbers List -->
          <div *ngIf="configuration.smsEnable" class="space-y-3">
            <div class="flex items-center justify-between">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'SMS Numbers' | transloco }}
              </label>
              <button
                type="button"
                (click)="addSMSNumber()"
                class="inline-flex items-center gap-1 text-sm bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition-colors duration-200"
              >
                <ng-icon name="matAddOutline" size="16" class="inline"></ng-icon>
                {{ 'Add Number' | transloco }}
              </button>
            </div>

            <div *ngIf="configuration.smsNumbers && configuration.smsNumbers.length === 0" class="text-sm text-gray-500 dark:text-gray-400 italic">
              {{ 'No SMS numbers added yet' | transloco }}
            </div>

            <div *ngFor="let smsNumber of configuration.smsNumbers; let i = index" class="flex gap-2">
              <input
                [(ngModel)]="smsNumber.number"
                [name]="'smsNumber' + i"
                type="tel"
                pattern="[0-9]{10}"
                maxlength="10"
                [attr.placeholder]="'1234567890' | transloco"
                required
                (ngModelChange)="checkForChanges()"
                class="flex-1 max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
              <button
                type="button"
                (click)="removeSMSNumber(i)"
                class="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 px-3 py-2 border border-red-300 dark:border-red-600 rounded-lg transition-colors duration-200"
                [attr.aria-label]="'Remove number'"
              >
                <ng-icon name="matDeleteOutline" size="20"></ng-icon>
              </button>
            </div>
            <p class="text-xs text-gray-500 dark:text-gray-400">
              {{ 'Enter 10-digit phone numbers without formatting (e.g., 1234567890)' | transloco }}
            </p>
          </div>
        </div>
      </div>  <!-- End SMS Settings Tab -->
      
      <!-- TAB 3: Notification Settings -->
      <div *ngIf="tabs[activeTab]?.name === 'Notification Settings'" class="space-y-6">
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matNotificationsOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Notification Settings' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>

          <!-- Notification Enable Toggle -->
          <div class="flex items-center mb-4">
            <input
              id="notificationsEnabled"
              [(ngModel)]="configuration.notificationsEnabled"
              name="notificationsEnabled"
              type="checkbox"
              (ngModelChange)="checkForChanges()"
              class="w-4 h-4 flex-shrink-0 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />
            <label for="notificationsEnabled" class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
              {{ 'Enable Email Notifications' | transloco }}
            </label>
          </div>

          <!-- Notification Emails List -->
          <div *ngIf="configuration.notificationsEnabled" class="space-y-3">
            <div class="flex items-center justify-between">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'Notification Emails' | transloco }}
              </label>
              <button
                type="button"
                (click)="addNotificationEmail()"
                class="inline-flex items-center gap-1 text-sm bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded transition-colors duration-200"
              >
                <ng-icon name="matAddOutline" size="16" class="inline"></ng-icon>
                {{ 'Add Email' | transloco }}
              </button>
            </div>

            <div *ngIf="notificationEmailRows.length === 0" class="text-sm text-gray-500 dark:text-gray-400 italic">
              {{ 'No notification emails added yet' | transloco }}
            </div>

            <div *ngFor="let emailRow of notificationEmailRows; let i = index; trackBy: trackByIndex" class="flex gap-2">
              <input
                [(ngModel)]="emailRow.value"
                [name]="'notificationEmail' + i"
                type="email"
                maxlength="128"
                [attr.placeholder]="'user@example.com' | transloco"
                required
                (ngModelChange)="onNotificationEmailChange()"
                class="flex-1 max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
              <button
                type="button"
                (click)="removeNotificationEmail(i)"
                class="text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300 px-3 py-2 border border-red-300 dark:border-red-600 rounded-lg transition-colors duration-200"
                [attr.aria-label]="'Remove email'"
              >
                <ng-icon name="matDeleteOutline" size="20"></ng-icon>
              </button>
            </div>
            <p class="text-xs text-gray-500 dark:text-gray-400">
              {{ 'Enter valid email addresses (e.g., user@example.com)' | transloco }}
            </p>
          </div>
        </div>
      </div>  <!-- End Notification Settings Tab -->

      <!-- TAB 4: Payment Settings -->
      <div *ngIf="tabs[activeTab]?.name === 'Payment Settings'" class="space-y-6">
        <!-- Payment Settings Section -->
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matPaymentOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Payment Settings' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>
          
          <!-- Moneris Environment Toggle -->
          <div *ngIf="hasMonerisModule" class="bg-gray-50 dark:bg-gray-700 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
            <div class="flex flex-col gap-4">
              <div>
                <h4 class="text-base font-semibold text-gray-900 dark:text-white mb-1">
                  {{ 'Moneris Payment Environment' | transloco }}
                </h4>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  {{ 'Select the environment for Moneris payment processing' | transloco }}
                </p>
              </div>
              
              <div class="flex items-center gap-4">
                <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {{ 'Environment:' | transloco }}
                </span>
                <button
                  type="button"
                  (click)="toggleMonerisEnvironment()"
                  [ngClass]="{
                    'bg-yellow-500 hover:bg-yellow-600': monerisEnvironmentMode === 'test',
                    'bg-green-600 hover:bg-green-700': monerisEnvironmentMode === 'production'
                  }"
                  class="relative inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-white rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 shadow-md"
                >
                  <!-- Test Mode Icon -->
                  <svg *ngIf="monerisEnvironmentMode === 'test'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                  </svg>
                  <!-- Production Mode Icon -->
                  <svg *ngIf="monerisEnvironmentMode === 'production'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                  </svg>
                  <span class="uppercase tracking-wide">{{ monerisEnvironmentMode === 'test' ? 'TEST MODE' : 'PRODUCTION' }}</span>
                </button>
              </div>
              
              <div class="mt-2 p-4 rounded-md" [ngClass]="{
                'bg-yellow-50 border border-yellow-200 dark:bg-yellow-900/20 dark:border-yellow-800': monerisEnvironmentMode === 'test',
                'bg-green-50 border border-green-200 dark:bg-green-900/20 dark:border-green-800': monerisEnvironmentMode === 'production'
              }">
                <div class="flex gap-3">
                  <svg class="w-5 h-5 mt-0.5 flex-shrink-0" [ngClass]="{
                    'text-yellow-600 dark:text-yellow-400': monerisEnvironmentMode === 'test',
                    'text-green-600 dark:text-green-400': monerisEnvironmentMode === 'production'
                  }" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                  </svg>
                  <div class="text-sm" [ngClass]="{
                    'text-yellow-800 dark:text-yellow-200': monerisEnvironmentMode === 'test',
                    'text-green-800 dark:text-green-200': monerisEnvironmentMode === 'production'
                  }">
                    <p class="font-medium mb-1">
                      <span *ngIf="monerisEnvironmentMode === 'test'">{{ 'Test Environment Active' | transloco }}</span>
                      <span *ngIf="monerisEnvironmentMode === 'production'">{{ 'Production Environment Active' | transloco }}</span>
                    </p>
                    <p class="text-xs">
                      <span *ngIf="monerisEnvironmentMode === 'test'">
                        {{ 'Use this mode for testing payments. No real transactions will be processed.' | transloco }}
                      </span>
                      <span *ngIf="monerisEnvironmentMode === 'production'">
                        {{ 'Real payment transactions will be processed. Use with caution.' | transloco }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Moneris Configuration Fields -->
          <div *ngIf="hasMonerisModule" class="mt-6 bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
            <h4 class="text-base font-semibold text-gray-900 dark:text-white mb-4">
              {{ 'Moneris Account Configuration' | transloco }}
            </h4>
            
            <div class="space-y-4">
              <!-- Store ID -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'Store ID' | transloco }} <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  [(ngModel)]="monerisConfiguration.storeId"
                  (ngModelChange)="checkForChanges()"
                  name="monerisStoreId"
                  class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                  [attr.placeholder]="'Enter Moneris Store ID' | transloco"
                  required
                />
              </div>
              
              <!-- API Token -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'API Token' | transloco }} <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <input
                    [type]="showApiToken ? 'text' : 'password'"
                    [(ngModel)]="monerisConfiguration.apiToken"
                    (ngModelChange)="checkForChanges()"
                    name="monerisApiToken"
                    class="w-full px-4 py-2 pr-12 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                    [attr.placeholder]="'Enter API Token' | transloco"
                    required
                  />
                  <button
                    type="button"
                    (click)="toggleApiTokenVisibility()"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none"
                    [title]="showApiToken ? ('Hide API Token' | transloco) : ('Show API Token' | transloco)"
                  >
                    <!-- Eye Icon (Show) -->
                    <svg *ngIf="!showApiToken" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                    </svg>
                    <!-- Eye Off Icon (Hide) -->
                    <svg *ngIf="showApiToken" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
                    </svg>
                  </button>
                </div>
              </div>
              
              <!-- Hosted Tokenization Profile ID -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'Hosted Tokenization Profile ID' | transloco }} <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  [(ngModel)]="monerisConfiguration.hostedTokenizationProfileId"
                  (ngModelChange)="checkForChanges()"
                  name="monerisProfileId"
                  class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                  [attr.placeholder]="'Enter Hosted Tokenization Profile ID' | transloco"
                  required
                />
              </div>
              
              <!-- Info Note -->
              <div class="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md">
                <div class="flex gap-3">
                  <svg class="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                  </svg>
                  <div class="text-sm text-blue-800 dark:text-blue-200">
                    <p class="font-medium mb-1">{{ 'Configuration Guide' | transloco }}</p>
                    <p class="text-xs">{{ 'These credentials can be obtained from your Moneris merchant account. Ensure you use the correct credentials for the selected environment (Test/Production).' | transloco }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Worldline Configuration Fields -->
          <div *ngIf="hasWorldlineModule" class="mt-6 bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
            <h4 class="text-base font-semibold text-gray-900 dark:text-white mb-4">
              {{ 'Worldline Account Configuration' | transloco }}
            </h4>

            <div class="space-y-4">
              <!-- Merchant ID -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'Merchant ID' | transloco }} <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  [(ngModel)]="worldlineConfiguration.merchantId"
                  (ngModelChange)="checkForChanges()"
                  name="worldlineMerchantId"
                  class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                  placeholder="Enter Worldline Merchant ID"
                  required
                />
              </div>

              <!-- Payments API Key -->
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'Payments API Key' | transloco }} <span class="text-red-500">*</span>
                </label>
                <div class="relative">
                  <input
                    [type]="showWorldlinePaymentsApiKey ? 'text' : 'password'"
                    [(ngModel)]="worldlineConfiguration.paymentsApiKey"
                    (ngModelChange)="checkForChanges()"
                    name="worldlinePaymentsApiKey"
                    class="w-full px-4 py-2 pr-12 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                    placeholder="Enter Payments API Key"
                    required
                  />
                  <button
                    type="button"
                    (click)="toggleWorldlinePaymentsApiKeyVisibility()"
                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none"
                    [title]="showWorldlinePaymentsApiKey ? ('Hide Payments API Key' | transloco) : ('Show Payments API Key' | transloco)"
                  >
                    <!-- Eye Icon (Show) -->
                    <svg *ngIf="!showWorldlinePaymentsApiKey" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                    </svg>
                    <!-- Eye Off Icon (Hide) -->
                    <svg *ngIf="showWorldlinePaymentsApiKey" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"></path>
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Info Note -->
              <div class="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md">
                <div class="flex gap-3">
                  <svg class="w-5 h-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path>
                  </svg>
                  <div class="text-sm text-blue-800 dark:text-blue-200">
                    <p class="font-medium mb-1">{{ 'Configuration Guide' | transloco }}</p>
                    <p class="text-xs">{{ 'These credentials can be obtained from your Worldline (Bambora) merchant account.' | transloco }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- PointAndPay Configuration Fields -->
          <div *ngIf="hasPointAndPayModule" class="mt-6 bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-200 dark:border-gray-600">
            <h4 class="text-base font-semibold text-gray-900 dark:text-white mb-4">
              {{ 'PointandPay Account Configuration' | transloco }}
            </h4>

            <div class="space-y-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'Payment URL ID' | transloco }} <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  [(ngModel)]="pointAndPayConfiguration.paymentUrlId"
                  (ngModelChange)="checkForChanges()"
                  name="pointAndPayPaymentUrlId"
                  class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                  required
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  {{ 'Product ID' | transloco }} <span class="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  [(ngModel)]="pointAndPayConfiguration.productId"
                  (ngModelChange)="checkForChanges()"
                  name="pointAndPayProductId"
                  class="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent dark:bg-gray-700 dark:text-white"
                  required
                />
              </div>

              <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
                <input
                  type="checkbox"
                  [(ngModel)]="pointAndPayConfiguration.testEnvironment"
                  (ngModelChange)="checkForChanges()"
                  name="pointAndPayTestEnvironment"
                />
                {{ 'Use PointandPay test environment' | transloco }}
              </label>
            </div>
          </div>
        </div>
      </div>  <!-- End Payment Settings Tab -->

      <!-- TAB: Security Settings -->
      <div *ngIf="tabs[activeTab]?.name === 'Security Settings'" class="space-y-6">
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matLockOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Security Settings' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Admin MFA -->
            <label for="adminMFAEnabled" class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
              <div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ 'Admin MFA' | transloco }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'Require multi-factor authentication for admin users' | transloco }}</p>
              </div>
              <div class="relative inline-flex items-center ms-4 flex-shrink-0">
                <input
                  id="adminMFAEnabled"
                  type="checkbox"
                  [(ngModel)]="configuration.adminMFAEnabled"
                  name="adminMFAEnabled"
                  (ngModelChange)="checkForChanges()"
                  class="sr-only peer"
                />
                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
              </div>
            </label>

            <!-- Customer MFA -->
            <label for="customerMFAEnabled" class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
              <div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ 'Customer MFA' | transloco }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'Require multi-factor authentication for customer users' | transloco }}</p>
              </div>
              <div class="relative inline-flex items-center ms-4 flex-shrink-0">
                <input
                  id="customerMFAEnabled"
                  type="checkbox"
                  [(ngModel)]="configuration.customerMFAEnabled"
                  name="customerMFAEnabled"
                  (ngModelChange)="checkForChanges()"
                  class="sr-only peer"
                />
                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
              </div>
            </label>

            <!-- Hide Financial Data (Operator) -->
            <label for="hideFinancialDataForOperator" class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
              <div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ 'Hide Financial Data from Staff' | transloco }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'Your staff will see station usage without account balances, rates, or prepayments.' | transloco }}</p>
                <p class="text-xs font-semibold text-amber-600 dark:text-amber-400 mt-1">{{ 'WARNING! Only enable if all customer billing occurs outside of Fusion Water+.' | transloco }}</p>
              </div>
              <div class="relative inline-flex items-center ms-4 flex-shrink-0">
                <input
                  id="hideFinancialDataForOperator"
                  type="checkbox"
                  [(ngModel)]="configuration.hideFinancialDataForOperator"
                  name="hideFinancialDataForOperator"
                  (ngModelChange)="checkForChanges()"
                  class="sr-only peer"
                />
                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
              </div>
            </label>

            <!-- Hide Financial Data (Customer) -->
            <label for="hideFinancialDataForCustomer" class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-700 rounded-lg border border-gray-200 dark:border-gray-600 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
              <div>
                <p class="text-sm font-medium text-gray-900 dark:text-white">{{ 'Hide Financial Data from Customers' | transloco }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">{{ 'Customers will see station usage without account balances, rates, or prepayments.' | transloco }}</p>
                <p class="text-xs font-semibold text-amber-600 dark:text-amber-400 mt-1">{{ 'WARNING! Only enable if all customer billing occurs outside of Fusion Water+.' | transloco }}</p>
              </div>
              <div class="relative inline-flex items-center ms-4 flex-shrink-0">
                <input
                  id="hideFinancialDataForCustomer"
                  type="checkbox"
                  [(ngModel)]="configuration.hideFinancialDataForCustomer"
                  name="hideFinancialDataForCustomer"
                  (ngModelChange)="checkForChanges()"
                  class="sr-only peer"
                />
                <div class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-600 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-500 peer-checked:bg-blue-600"></div>
              </div>
            </label>
          </div>
        </div>
      </div>  <!-- End Security Settings Tab -->

      <!-- TAB: Sync Service -->
      <div *ngIf="tabs[activeTab]?.name === 'Sync Service'" class="space-y-6">
        <div>
          <h3 class="w-full font-bold text-xl mb-3 border-b-2 pb-2 text-gray-900 dark:text-white flex items-center gap-2">
            <ng-icon name="matSyncOutline" size="20" class="text-blue-600"></ng-icon>
            <span>{{ 'Sync Service' | transloco }}</span>
            <div class="flex-1 h-px bg-gray-200 dark:bg-gray-700"></div>
          </h3>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <!-- Sync Interval -->
            <div>
              <label for="commServiceSyncIntervalMinutes" class="block text-sm font-medium text-gray-700 dark:text-gray-100 border-b border-blue-300 pb-1 mb-1">
                {{ 'Sync Interval (Minutes)' | transloco }}
              </label>
              <input
                id="commServiceSyncIntervalMinutes"
                [(ngModel)]="$any(configuration).commServiceSyncIntervalMinutes"
                name="commServiceSyncIntervalMinutes"
                type="number"
                min="1"
                autocomplete="off"
                (ngModelChange)="checkForChanges()"
                class="w-full max-w-full flex-shrink-0 px-3 py-2 bg-gray-50 border border-blue-300 dark:border-gray-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
              />
            </div>
          </div>
        </div>
      </div>  <!-- End Sync Service Tab -->

    </form>
            </div>
          </div>
        </div>

  <!-- Bottom shadow -->
  <div class="pointer-events-none w-full h-2 z-20 -mt-2"
       style="background: linear-gradient(to top, rgba(0,0,0,0.18), transparent);"></div>

  <!-- Footer with buttons -->
  <div class="bg-gray-100 dark:bg-gray-800 flex flex-row items-center justify-center p-4 border-t rounded-b dark:border-gray-600 shadow-lg z-10 relative max-sm:rounded-none gap-4">
    <!-- Save button -->
    <button
      type="button"
      (click)="onSave()"
      class="flex-1 bg-blue-800 hover:bg-blue-900 text-white transition-colors duration-200 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-sm px-5 py-2.5 text-center min-w-[120px] max-w-[200px]"
      [attr.aria-label]="'Save configuration'"
    >
      {{ 'Save' | transloco }}
    </button>

    <!-- Cancel button -->
    <button
      type="button"
      (click)="onCancel()"
      class="flex-1 bg-gray-500 border-gray-500 text-white hover:bg-gray-600 hover:text-white transition-colors duration-200 focus:ring-4 focus:outline-none focus:ring-gray-300 rounded-lg text-sm px-5 py-2.5 text-center min-w-[120px] max-w-[200px]"
      [attr.aria-label]="'Cancel'"
    >
      {{ 'Cancel' | transloco }}
    </button>
  </div>
</div>
</div>
</div>

<!-- Success Message Popup -->
<div
  *ngIf="showSuccessMessage"
  class="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50"
  (click)="closeSuccessMessage()"
>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4"
    (click)="$event.stopPropagation()"
  >
    <div class="flex flex-col items-center justify-center p-8">
      <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8 text-green-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <h3 class="text-xl font-medium text-gray-900 dark:text-white mb-3">
        {{ 'Success!' | transloco }}
      </h3>
      <p class="text-sm text-gray-700 dark:text-gray-100 text-center mb-6">
        {{ 'Configuration saved successfully.' | transloco }}
      </p>
      <button
        (click)="closeSuccessMessage()"
        class="bg-green-600 hover:bg-green-700 text-white text-sm font-medium py-2 px-6 rounded transition-colors duration-200"
        [attr.aria-label]="'Close success message and continue' | transloco"
      >
        {{ 'Continue' | transloco }}
      </button>
    </div>
  </div>
</div>

<!-- Unsaved Changes Warning Popup -->
<div
  *ngIf="showUnsavedWarning"
  class="fixed inset-0 z-[70] flex items-center justify-center bg-black bg-opacity-50"
  (click)="dismissCancelWarning()"
>
  <div
    class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full mx-4"
    (click)="$event.stopPropagation()"
  >
    <div class="flex flex-col items-center justify-center p-8">
      <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-8 w-8 text-yellow-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z"
          />
        </svg>
      </div>
      <h3 class="text-xl font-medium text-gray-900 dark:text-white mb-3">
        {{ 'Discard Unsaved Changes?' | transloco }}
      </h3>
      <p class="text-sm text-gray-700 dark:text-gray-100 text-center mb-6">
        {{ 'You have unsaved changes that will be permanently lost if you close this form. Are you sure you want to discard your changes?' | transloco }}
      </p>
      <div class="flex gap-3">
        <button
          (click)="confirmCancel()"
          class="bg-red-600 hover:bg-red-700 text-white text-sm font-medium py-2 px-6 rounded transition-colors duration-200"
        >
          {{ 'Discard Changes' | transloco }}
        </button>
        <button
          (click)="dismissCancelWarning()"
          class="bg-blue-800 hover:bg-blue-900 text-white text-sm font-medium py-2 px-6 rounded transition-colors duration-200"
        >
          {{ 'Keep Editing' | transloco }}
        </button>
      </div>
    </div>
  </div>
</div>
